import React from "react";


const ReportWidget = ({ title, heading, imageName, page, alt, iconClass, basePage, reportPage, rval, menu } ) =>
{
    const imageSrc = "/admin/assets/libs/school360/images/" + imageName ;

    const href = `${basePage}?lang=en&page=${page}&report=${reportPage}&menu=${menu}&return=${rval}` ;

    return (
        <div className="widget report-widget">
            <div className="widget-content padding ">
                <h5>{heading}</h5>
                <a className={iconClass} href={href} title={title}>
                    <img src={imageSrc} alt={alt} />
                </a>
            </div>
        </div>
    )
}

export default ReportWidget ;
